import { Routes } from '@angular/router';
import { GinopDetailsComponent } from './components/ginop-details/ginop-details.component';
import { GinopListComponent } from './components/ginop-list/ginop-list.component';
import { GinopRegistrationComponent } from './components/ginop-registration/ginop-registration.component';
import { GinopEventResolver } from './ginop-event.resolver';
import { GinopHomeResolver } from './ginop-home.resolver';
import { GinopComponent } from './ginop.component';

export const GinopRouting: Routes = [
  {
    path: '',
    component: GinopComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: GinopListComponent,
        resolve: { data: GinopHomeResolver },
        data: { pageType: 'ginop-list' },
      },
      {
        path: ':slug/exhibitor',
        component: GinopRegistrationComponent,
        resolve: { data: GinopEventResolver },
        data: { pageType: 'exhibitor' },
      },
      {
        path: ':slug/participant',
        component: GinopRegistrationComponent,
        resolve: { data: GinopEventResolver },
        data: { pageType: 'participant' },
      },
      {
        path: ':slug',
        component: GinopDetailsComponent,
        resolve: { data: GinopEventResolver },
      },
    ],
  },
];
